export const DELIVERY_METHOD = {
  DELIVERY_BY_SERVICE: 'DELIVERY_BY_SERVICE',
  DELIVERY_BY_STORE: 'DELIVERY_BY_STORE',
} as const;

export const deliveryMethod = {
  [DELIVERY_METHOD.DELIVERY_BY_SERVICE]: '配達代行',
  [DELIVERY_METHOD.DELIVERY_BY_STORE]: '自社配達',
} as const;

export type DeliveryMethod = keyof typeof deliveryMethod;

export const deliveryMethods = [
  {
    value: DELIVERY_METHOD.DELIVERY_BY_SERVICE,
    name: deliveryMethod.DELIVERY_BY_SERVICE,
  },
  {
    value: DELIVERY_METHOD.DELIVERY_BY_STORE,
    name: deliveryMethod.DELIVERY_BY_STORE,
  },
];
